class I18NEvent {
	static get TRANSLATION_COMPLETE(){
		return "translation_complete";
	}
}
export {I18NEvent}